import { mergeConfig } from "./config.base";

export const config = mergeConfig({
  CLIENT_ID: "de317d9d-c980-48ea-bc13-6adb466ac967",
  AUTH_URL: "https://identity.inflosoftware.com",
  ENVIRONMENTS: [
    { name: "EMEA", url: "https://emea.inflosoftware.com/" },
    { name: "US", url: "https://us.inflosoftware.com/" },
    { name: "AMER", url: "https://amer.inflosoftware.com/" },
    { name: "APAC", url: "https://apac.inflosoftware.com/" },
    { name: "RSM US", url: "https://rsmus.inflosoftware.com/" },
    { name: "MA US", url: "https://maus.inflosoftware.com/" },
    { name: "COHN", url: "https://cohnreznick.inflosoftware.com/" },
    { name: "CRUSPP", url: "https://cohnreznick-preprod.inflosoftware.com/" },
  ],
});
